import SubscriptionsScene from '../Subscriptions';

export default function BeginWorkSubscriptions() {
    return <SubscriptionsScene />;
}
